import { footerColumns } from "@/mocks/homeData";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 py-10 md:px-8 md:py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-fire-fill text-xl" style={{ lineHeight: 1 }} />
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-heading text-lg font-black text-background-50">黑料大瓜</span>
                <span className="font-label text-[11px] text-background-400">
                  细节分析 · 完整时间线 · 内幕深扒
                </span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-xs leading-relaxed text-background-300">
              把每个瓜的来龙去脉摆清楚，从第一条动态到最新一次改口，配上可核对的时间线与材料索引，让你看完就是
              最懂脉络的人。
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <a
                href="#feed"
                className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-background-50/10 px-3 py-2 text-xs text-background-100 transition-colors hover:bg-background-50/20"
              >
                <i className="ri-rss-line h-4 w-4" style={{ lineHeight: 1 }} />
                订阅更新
              </a>
              <a
                href="#discussion"
                className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-background-50/10 px-3 py-2 text-xs text-background-100 transition-colors hover:bg-background-50/20"
              >
                <i className="ri-mail-send-line h-4 w-4" style={{ lineHeight: 1 }} />
                提交线索
              </a>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-bold text-background-50">{column.title}</h4>
              <ul className="mt-3 flex flex-col gap-2">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="text-xs text-background-300 transition-colors hover:text-background-50"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-background-50/15 pt-5 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-background-400">
            本站内容为公开信息整理与网民观点聚合，涉及未证实内容均标注「待补齐」，请勿作为事实依据。
          </p>
          <p className="shrink-0 font-label text-xs text-background-400">
            © 2026 黑料大瓜 · 仅供浏览与讨论
          </p>
        </div>
      </div>
    </footer>
  );
}